import { render, staticRenderFns } from "./catalogueMain.vue?vue&type=template&id=14024462&scoped=true&"
import script from "./catalogueMain.vue?vue&type=script&lang=js&"
export * from "./catalogueMain.vue?vue&type=script&lang=js&"
import style0 from "./catalogueMain.vue?vue&type=style&index=0&id=14024462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14024462",
  null
  
)

export default component.exports